import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { IInitialEWalletValues } from '../edit-bank-info/interfaces';

export const editEWallet = async ({
  id,
  ...data
}: Partial<IInitialEWalletValues>) => {
  const formData = new FormData();

  if (data.logo) {
    const modifiedAvatar =
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (data.logo as any) instanceof File
        ? data.logo
        : new Blob([data.logo], {
            type: 'image/png',
          });
    formData.append('logo', modifiedAvatar);
    formData.append('provider_name', data.provider_name ?? '');
    formData.append('recipient_name', data.recipient_name ?? '');
    formData.append(
      'recipient_number',
      data.recipient_number?.toString() ?? ''
    );
  }

  const { logo, ...restData } = data;
  return await request({
    url: `ewallets/${id}/`,
    method: 'PATCH',
    body: typeof logo === 'string' ? restData : formData,
  });
};

export const useEditEWallet = () => {
  return useMutation({
    mutationFn: editEWallet,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('Wallet has updated successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getBankInfo],
      });
    },
  });
};
